<!-- 控销组列表 controlruleDataList -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false"
            append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <qualifapplyInitListAction v-if="showStatus" ref="qualifapplyInitListAction" @drawerCancel="drawerCancel"
                @toDetail="toDetail" :actionData="actionData"></qualifapplyInitListAction>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="controlGoods.hisSearch" :searchList="controlGoods.hisSearch" :getRequestData="getRequestData"
                    @searchData="searchData" @openSearch="openSearch"></v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="controlGoods.hisList" stripe :data="returnData.list" :height="tableHeight"
                :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
                <el-table-column label="选择操作" align="center" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column v-for="(tableValye, tableKey) in controlGoods.hisList" :key="tableKey" align="center"
                    show-overflow-tooltip :prop="tableValye.entityField" :min-width="tableValye.fieldWeight"
                    :label="tableValye.showField">
                    <template slot-scope="scope">
                        <span v-if="tableValye.fieldType == 'date'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }} </span>
                        </span>
                        <el-tag size="mini" v-else-if="tableValye.fieldType == 'formatter'">{{
            $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{
            scope.row[tableValye.entityField] }}</a>
                        </span>
                        <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData"
                @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog title="请输入资质编号" v-if="subDia" :visible.sync="subDia" width="400px">
            <el-input v-model="quaCode"></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelsubmitDataAction">取 消</el-button>
                <el-button type="primary" @click="submitDataAction()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue";
import qualifapplyInitListAction from "../../byComponents/qualifapplyInitListAction.vue";
import qualifapplyInitList from "./qualifapplyInitList";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        qualifapplyInitListAction,
    },
    data() {
        //这里存放数据
        return {
            controlGoods: qualifapplyInitList,
            tableHeight: 0,
            getRequestData: {
                bgmName: "",
                businessId: "",
                start: "",
                end: "",
                ormId: "",
                page: 1,
                rows: 30,
                quaType:"",
                quaCode:"",
                unitName:"",
                opmName:""
            },
            returnData: {
                total: 0, // 总条数
                list: [],
            },
            buttonList: [],
            selectedDataIndex: 0,
            showStatus: false,
            actionData: {},
            DialogVisible: false,
            seTitle: "",
            seWidth: "",
            seId: "",
            sField: "",
            seType: "",
            parentSearchData: {},
            subDia: false,
            quaCode: ""

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.seType = type;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //检索带回数据
        changeInputModel(val) {
            console.log(val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData)
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true;
                    this.actionData = {
                        cate: 0,
                        formData: this.controlGoods.from,
                        oldData: {},
                        orderId: "",
                        printSouce: "",
                        printJurId: "",
                    };
                    break;
                case 1:
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.showStatus = true;
                    this.actionData = {
                        cate: 1,
                        formData: this.controlGoods.from,
                        oldData: dataInfo,
                        orderId: dataInfo.psomId,
                        printSouce: "",
                        printJurId: "",
                    };
                    break;
                case 2:
                    if (this.returnData.list.length < 1) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.delDataAction()
                    break;
                case 3:
                window.location.href = `${ this.$store.getters.getConfig.requestUrl}/qualifapply/exportQualifapply?start=`
                + this.getRequestData.start
                +'&end='+ this.getRequestData.end
                +'&unitName='+ this.getRequestData.unitName
                +'&quaCode='+ this.getRequestData.quaCode
                +'&quaType='+ this.getRequestData.quaType
                +'&opmName='+ this.getRequestData.opmName

                    break;
                case 999:
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.showStatus = true;
                    this.actionData = {
                        cate: 2,
                        formData: this.controlGoods.from,
                        oldData: dataInfo,
                        orderId: dataInfo.psomId,
                        printSouce: "",
                        printJurId: "",
                    };
                    break;
            }
        },
        async submitDataAction() {
            this.$confirm("确定要提交审核吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let responseData = await this.$http.qualifapplySubmit({ ids: [this.returnData.list[this.selectedDataIndex].quaId] });
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功",
                        });
                        this.quaCode = ""
                        this.subDia = false
                        this.getDataList()
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },
        cancelsubmitDataAction() {
            this.quaCode = ""
            this.subDia = false
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path);
            this.$refs["customDesign"].openBox(
                pathInfo.jurId,
                this.pageShowData,
                pathInfo.jurName
            );
        },
        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }

            this.$confirm("此操作将作废该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.quaId],
                    };
                    let responseData = await this.$http.qualifapplyCancel(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: responseData.message,
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 子组件触发
        drawerCancel(e) {
            this.showStatus = false;
            if (e == 1) this.getDataList();
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: {
                            isPenetrate,
                        }, //参数
                    },
                    "*"
                );
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton();
            
        },
// 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },
        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },
        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.qualifapplyQueryHis(
                this.getRequestData
            );
            if (responseData && responseData.status == 200) {
                let resData = JSON.parse(JSON.stringify(responseData));
                this.returnData.list = resData.result.list;
                this.returnData.pages = resData.result.pages;
                this.returnData.total = resData.result.total;
                this.returnData.pageNum = resData.result.pageNum;
                this.selectedDataIndex = 0;

            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        var obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        for (const key in obj) {
            this.$set(this.getRequestData, key, obj[key])
        }
        this.getDataList();
        this.getButtonList();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}
</style>